import { TFunction } from 'i18next';

type FlatDataItem = {
  cmhcAccountNumber: number;
};

export const cmhcAccountNumberOptionsGrouped = (flatData: FlatDataItem[], t: TFunction) => {
  const cmhcAccountNumberCountMap = new Map<string, number>();

  flatData.forEach((item) => {
    const cmhcAccountNumber = item.cmhcAccountNumber.toString();
    cmhcAccountNumberCountMap.set(
      cmhcAccountNumber,
      (cmhcAccountNumberCountMap.get(cmhcAccountNumber) || 0) + 1
    );
  });

  return Array.from(cmhcAccountNumberCountMap.entries()).map(([id, count]) => ({
    label: id,
    value: id,
    chipLabel: id
  }));
};
